import { useSelectedFiltersCount as useBaseSelectedFiltersCount } from "@nosto/search-js/preact/hooks"
/**
 * @group Hooks
 * @returns The number of selected filters.
 * @example
 * ```jsx
 * import { useSelectedFiltersCount } from '@nosto/preact'
 * export default () => {
 *    const selectedFiltersCount = useSelectedFiltersCount()
 *    return (
 *        <div>
 *            {selectedFiltersCount} filters selected
 *        </div>
 *    )
 * }
 * ```
 */
export function useSelectedFiltersCount(): number {
    return useBaseSelectedFiltersCount()
}
